export function requestsMapperListResponse(json, headers) {
    return {
        data: json.map((resource) => ({
            ...resource,
            id: resource.objectId || resource.id || resource._id,
        })),
        total: headers.get("X-Total-Count") ? parseInt(headers.get("X-Total-Count").split("/").pop(), 10) : 1000,
    };
}

export function requestsMapperGetOneResponse(json) {
    // The backend usually returns { result: { ... } } or just the object
    // Based on paybills: { result: { ... } }
    const record = json.result || json;
    return {
        data: { ...record, id: record.objectId || record.id || record._id },
    };
}

export function fixCreateRequestId(params, json) {
    const record = json.result || json;
    return {
        data: { ...params.data, id: record.objectId || record.id || record._id },
    };
}

export function fixUpdateRequestId(json) {
    const record = json.result || json;
    // Map objectId to requestId as per spec requirement
    return {
        data: {
            ...record,
            id: record.objectId || record.id || record._id,
            requestId: record.objectId || record.id || record._id
        },
    };
}

export function fixGetManyRequests(headers, json) {
    return {
        data: json.map((resource) => ({
            ...resource,
            id: resource.objectId || resource.id || resource._id,
        })),
    };
}
